import React, { useEffect, useRef, useState } from 'react';
import { getScrollParent } from '../../AIEmployees/useReveal';
import { Button } from 'antd';
import { ArrowRightOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import './LinearClose.css';

/**
 * LinearClose — §4.8. Vision close + CTA.
 */
const LinearClose = ({ ctaLabel, onConnect, connecting }) => {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!ref.current) return undefined;
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setVisible(true);
            io.disconnect();
          }
        });
      },
      // Fast-scroll-safe (matches useReveal): correct scroll root + a full
      // viewport of lookahead + any-pixel threshold.
      { root: getScrollParent(ref.current), threshold: 0, rootMargin: '0px 0px 100% 0px' }
    );
    io.observe(ref.current);
    return () => io.disconnect();
  }, []);

  return (
    <section className="linear-close" ref={ref}>
      <div className="linear-close__gradient" aria-hidden="true" />
      <div className={`linear-close__inner reveal ${visible ? 'is-visible' : ''}`}>
        <h2 className="linear-close__title display-font">
          Put your whole team inside Linear.
        </h2>
        <p className="linear-close__sub">
          5-second setup. Pay per task. Cancel anytime.
        </p>
        <div className="linear-close__ctas">
          <Button
            type="primary"
            size="large"
            className="linear-close__cta-primary"
            onClick={onConnect}
            loading={connecting}
            data-msc-suppress
          >
            {ctaLabel}
            <ArrowRightOutlined />
          </Button>
          <Link to="/pricing" className="linear-close__cta-secondary">
            View pricing
          </Link>
        </div>
      </div>
    </section>
  );
};

export default LinearClose;
